var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngiosperms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,55 C50,70 50,82 50,93",
    fill: "none",
    stroke: "#388E3C",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,74 C58,68 67,70 70,64 C62,62 54,66 50,74 Z",
    fill: "#66BB6A",
    stroke: "#388E3C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 40)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 23,
    rx: 10,
    ry: 16,
    fill: "#EC407A",
    stroke: "#AD1457",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72 50 40)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 23,
    rx: 10,
    ry: 16,
    fill: "#EC407A",
    stroke: "#AD1457",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144 50 40)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 23,
    rx: 10,
    ry: 16,
    fill: "#EC407A",
    stroke: "#AD1457",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216 50 40)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 23,
    rx: 10,
    ry: 16,
    fill: "#EC407A",
    stroke: "#AD1457",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288 50 40)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 23,
    rx: 10,
    ry: 16,
    fill: "#EC407A",
    stroke: "#AD1457",
    strokeWidth: 1.8
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 9.5,
    fill: "#FFCA28",
    stroke: "#F9A825",
    strokeWidth: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngiosperms);
export default __webpack_public_path__ + "static/media/angiosperms.56818d5a51de8b5606514ee4c732173a.svg";
export { ForwardRef as ReactComponent };